import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#69005b',
  width = '100%',
  className = '',
  viewBox = '0 0 37.953 101.208',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      id="male-solid"
      className="icon"
      d="M18.976,0A12.651,12.651,0,1,1,6.325,12.651,12.651,12.651,0,0,1,18.976,0m9.488,28.465H26.219a17.372,17.372,0,0,1-14.485,0H9.488A9.488,9.488,0,0,0,0,37.953V64.836A4.744,4.744,0,0,0,4.744,69.58H7.907V96.463a4.744,4.744,0,0,0,4.744,4.744H25.3a4.744,4.744,0,0,0,4.744-4.744V69.58h3.163a4.744,4.744,0,0,0,4.744-4.744V37.953A9.488,9.488,0,0,0,28.465,28.465Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
